import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './productPages.css'

function Dehumidifier() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='pp-empty product-surface-card'>
          <Typography className='pp-empty-title'>Dehumidifiers</Typography>
          <Typography className='pp-empty-text'>
            We're putting this page together. In the meantime, reach out and we'll
            share specifications and recent installations directly.
          </Typography>
          <Button className='pp-cta-btn' onClick={() => navigate('/contactus')}>
            Contact us
          </Button>
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Dehumidifier
